module.exports = __webpack_public_path__ + "img/piece-complete-1.294f62e8.svg";